import getPrecisedNumber from './getPrecisedNumber';

export default function getFormattedAmount(
  value: number,
  modifier: number,
): string {
  const amount = value / modifier;
  const precision = modifier.toString().length - 1;

  return getPrecisedNumber(amount, precision);
}
